import React from 'react';
import PropTypes from 'prop-types';
import useIterateModifiers from '@/hooks/useIterateModifiers';

const InfoBox = ({ title, subTitle }) => (
  <div className='dln-noticeBox__description'>
    {title && <span className='dln-noticeBox__title'>{title}</span>}
    {subTitle && (
      <span
        className='dln-noticeBox__copy'
        dangerouslySetInnerHTML={{
          __html: subTitle,
        }}
      />
    )}
  </div>
);

InfoBox.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

InfoBox.defaultProps = {
  title: null,
  subTitle: null,
};

const NoticeBox = ({
  modifiers,
  glyph,
  title,
  subTitle,
  linkName,
  linkUrl,
  linkTarget,
}) => {
  const modifiersString = useIterateModifiers('dln-noticeBox--', modifiers);
  return (
    <div className={`dln-noticeBox ${modifiersString}`}>
      <div className='dln-noticeBox__content'>
        <div className='dln-noticeBox__icon'>
          <i className='dln-icn dln-icn--iconfont'>{glyph}</i>
        </div>
        {!linkName ? (
          <a href={linkUrl} className='dln-noticeBox__content'>
            <InfoBox title={title} subTitle={subTitle} />
          </a>
        ) : (
          <InfoBox title={title} subTitle={subTitle} />
        )}
      </div>
      {linkName && (
        <a href={linkUrl} target={linkTarget} className='dln-noticeBox__link'>
          {linkName}
        </a>
      )}
    </div>
  );
};

NoticeBox.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.string),
  glyph: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  linkName: PropTypes.string,
  linkUrl: PropTypes.string,
  linkTarget: PropTypes.string,
  title: PropTypes.string,
};

NoticeBox.defaultProps = {
  modifiers: [],
  title: null,
  subTitle: null,
  linkName: null,
  linkUrl: null,
  linkTarget: null,
};

export default NoticeBox;
